export enum TransferTypes{
    bank,
    cash
}

export class TransferType{
    id:string=''
    label : string ='';
}